import { render, staticRenderFns } from "./LoginSms.vue?vue&type=template&id=077abfa8&scoped=true&"
import script from "./LoginSms.vue?vue&type=script&lang=js&"
export * from "./LoginSms.vue?vue&type=script&lang=js&"
import style0 from "./LoginSms.vue?vue&type=style&index=0&id=077abfa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077abfa8",
  null
  
)

component.options.__file = "LoginSms.vue"
export default component.exports